module.exports = __webpack_public_path__ + "media/images/logos/logo-masters-65163529f1845c726989b6bd80b8433d.svg";